import omazeUI from '../../../package.json';

export function getAssetBaseUrl (): string {
    const OMAZE_UI_VERSION: string = omazeUI.version;
    const assetBaseURL: string = `//assets.prd.omazedev.com/omaze-ui/${OMAZE_UI_VERSION}`;

    return assetBaseURL;
}
